var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19241 9.78432C9.09456 9.75232 8.4761 9.47355 8.86256 8.29878H8.85702C9.86441 7.26124 10.6343 5.5917 10.6343 3.94801C10.6343 1.42063 8.95364 0.0957031 7.00041 0.0957031C5.04595 0.0957031 3.37456 1.42001 3.37456 3.94801C3.37456 5.59847 4.1401 7.27478 5.15364 8.30986C5.54872 9.34616 4.84225 9.73078 4.69456 9.78432C2.64902 10.5246 0.249023 11.8729 0.249023 13.204V13.7031C0.249023 15.5166 3.76533 15.9289 7.01948 15.9289C10.2786 15.9289 13.7506 15.5166 13.7506 13.7031V13.204C13.7506 11.8329 11.3389 10.4951 9.19241 9.78432ZM5.79795 15.1437C5.79795 13.5751 6.79672 11.4575 6.79672 11.4575L6.10564 10.9154C6.10564 10.3972 6.99979 9.85509 6.99979 9.85509C6.99979 9.85509 7.89148 10.4059 7.89148 10.9154L7.20287 11.4575C7.20287 11.4575 8.20164 13.5671 8.20164 15.1609C8.20164 15.4108 5.79795 15.3529 5.79795 15.1437Z",
    fill: "#8F91A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.41e2ea58.svg";
export { ForwardRef as ReactComponent };